import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

export default function ContactUs() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
    const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!fullName || !email || !message) {
      setError("All fields are required.");
      return;
    }
    // Simple email validation
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setSuccess("Message sent successfully!");
    setFullName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className="min-h-screen bg-[#130828] flex flex-col items-center py-8 px-4">
          <div className="flex  items-center text-center w-full max-w-md relative mb-8">
                     <button
                            className="mb-8"
                            onClick={() => navigate(-1)}
                            aria-label="Go back"
                          >
                            <BsArrowLeft  width={20} height={20} color="#fff" />
                          </button>
      <h2 className="text-white mx-auto text-2xl font-bold mb-8">Contact Us</h2>
    </div>
      <form onSubmit={handleSubmit} className="w-full max-w-md  rounded-2xl p-6 shadow-lg flex flex-col gap-5">
        <div>
          {/* <label className="block text-white text-sm mb-2">Full Name</label> */}
          <input
            type="text"
            className="w-full px-4 py-2 rounded-lg bg-white text-[#394452] border border-[#39324D] focus:outline-none focus:border-[#6499FF]"
            value={fullName}
            placeholder="Full Name"
            onChange={e => setFullName(e.target.value)}
            required
          />
        </div>
        <div>
          {/* <label className="block text-white text-sm mb-2">Email</label> */}
          <input
            type="email"
            className="w-full px-4 py-2 rounded-lg  bg-white text-[#394452] border border-[#39324D] focus:outline-none focus:border-[#6499FF]"
            value={email}
            placeholder="Email"
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          {/* <label className="block text-white text-sm mb-2">Message</label> */}
          <textarea
            className="w-full px-4 py-2 rounded-lg  bg-white text-[#394452] border border-[#39324D] focus:outline-none focus:border-[#6499FF] min-h-[100px]"
            value={message}
            placeholder="Message"
            onChange={e => setMessage(e.target.value)}
            required
          />
        </div>
        {error && <div className="text-red-400 text-sm">{error}</div>}
        {success && <div className="text-green-400 text-sm">{success}</div>}
        <button
          type="submit"
          className="w-full bg-[#9FCC3B]  text-black font-semibold py-3 rounded-lg transition"
        >
          SEND MESSAGE
        </button>
      </form>
    </div>
  );
}
